module.exports = __webpack_public_path__ + "img/home-12.82ca0a22.png";